/**
 * @generated SignedSource<<f94fb9346abef5735caf9ca4f7f380b3>>
 * @relayHash 8150941a1b2e73a70a6246c0ca0e3da1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8150941a1b2e73a70a6246c0ca0e3da1

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type NutritionalCondition = "CARDIOVASCULAR_DISEASES" | "DISEASES_OF_THE_DIGESTIVE_SYSTEM" | "FOOD_ALLERGIES_OR_ALLERGIC_REACTIONS_TO_FOOD_COMPONENTS" | "KIDNEY_DISEASES" | "MALNUTRITION_AND_MALNOURISHMENT_CONDITIONS" | "METABOLIC_DISEASES" | "OBESITY";
export type ObesityTherapy = "INDIVIDUAL_THERAPY" | "MULTIPROFESSIONAL_STRUCTURED_INDIVIDUAL_THERAPY";
export type ReasonForNutritional = "ACCIDENT" | "IVMV" | "SICKNESS";
export type Ch_createNutritionalPrescriptionInput = {
  additionalInformation?: string | null;
  allergies: ReadonlyArray<string>;
  conditions: ReadonlyArray<string>;
  diagnosisCode: string;
  healthcareProviderId?: string | null;
  isAdult: boolean;
  language: Language;
  medicationIds: ReadonlyArray<string>;
  nutritionalConditions: ReadonlyArray<NutritionalCondition>;
  obesityTherapy?: ObesityTherapy | null;
  patientId: string;
  progressNoteId: string;
  reason: ReasonForNutritional;
  treatmentUnit: number;
};
export type useChCreateNutritionalCounsellingMutation$variables = {
  input: Ch_createNutritionalPrescriptionInput;
};
export type useChCreateNutritionalCounsellingMutation$data = {
  readonly ch_createNutritionalPrescription: {
    readonly ch_NutritionalPrescription: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"chNutritionalCounsellingFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChCreateNutritionalCounsellingMutation = {
  response: useChCreateNutritionalCounsellingMutation$data;
  variables: useChCreateNutritionalCounsellingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChCreateNutritionalCounsellingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createNutritionalPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_createNutritionalPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NutritionalPrescription",
            "kind": "LinkedField",
            "name": "ch_NutritionalPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "chNutritionalCounsellingFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChCreateNutritionalCounsellingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createNutritionalPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_createNutritionalPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NutritionalPrescription",
            "kind": "LinkedField",
            "name": "ch_NutritionalPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "additionalInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diagnosisCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "healthcareProviderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allergies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "conditions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medicationIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nutritionalConditions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "obesityTherapy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "treatmentUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentFileMetadata",
                "kind": "LinkedField",
                "name": "fileMetadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lengthInKilobytes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8150941a1b2e73a70a6246c0ca0e3da1",
    "metadata": {},
    "name": "useChCreateNutritionalCounsellingMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0b9bfe0718cce1b96511e03bc7727bca";

export default node;
